module.exports = __webpack_public_path__ + "static/media/filterUp.5f6507dd.svg";